import { render, staticRenderFns } from "./dealInfo-help.vue?vue&type=template&id=5c77db83&scoped=true&"
import script from "./dealInfo-help.vue?vue&type=script&lang=js&"
export * from "./dealInfo-help.vue?vue&type=script&lang=js&"
import style0 from "./dealInfo-help.vue?vue&type=style&index=0&id=5c77db83&scoped=true&lang=css&"
import style1 from "./dealInfo-help.vue?vue&type=style&index=1&id=5c77db83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77db83",
  null
  
)

export default component.exports